/**
 * Firebase Performance Monitoring (web). Once initialized, the SDK auto-collects:
 *  - page-load traces (first paint, domContentLoaded, load) per URL pattern
 *  - HTTP/S network request timings (response time / payload size) for fetch/XHR
 * out of the box — no per-call instrumentation needed. Custom traces can be added
 * later via `trace(perf, name)` if we want to time specific flows.
 *
 * Reuses the shared Firebase app; no-op without config or in local dev.
 */

import { getPerformance } from 'firebase/performance';
import { getFirebaseApp } from './firebase-app';

let started = false;

/** Start Firebase Performance Monitoring. Idempotent; safe to call at app boot. */
export function initPerformance(): void {
  if (started) return;
  started = true;
  const app = getFirebaseApp();
  if (!app) return;
  try {
    // Auto instrumentation (page load + network requests) is on by default.
    getPerformance(app);
  } catch {
    // performance monitoring must never crash the app
  }
}
